






































































































import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import DateRange from '@/components/common/DateRange.vue';

import {
  gte, lte,
} from '@/classes/pimcore-filtering/Filters';

import { DataPagination } from 'vuetify';

import Draggable from 'vuedraggable';
import DraggableDataTable from '@/components/ApplicationProcessing/DraggableDataTable.vue';
import { TableData } from '@/types/DraggableDataTableTypes';
import { accountingSheet } from '@/utils/config';
import Axios from 'axios';
import PlatformsAndSuppliersMixin from '@/mixins/PlatformsAndSuppliersMixin';

import _ from 'lodash';
import moment from 'moment';

@Component({
  components: {
    DraggableDataTable,
    Draggable,
    DateRange,
  },
})
export default class AccountingSheetsList extends mixins(PlatformsAndSuppliersMixin) {
  @Prop({
    type: String,
    required: false,
    default: 'AccountingSheetsList',
  }) readonly localStoragePrefix!: string;

  previewFormData: Record<string, any> | null = null;

  previewFormOptions: Record<string, any[]> | null = null;

  selectedSuppliers: string[] = [];

  defaultPlatform: any = '';

  dates: string[] = [];

  defaultDates: string[] = [];

  idsFilter = '';

  gte = (type: string, value: string) => gte(type, value)

  lte = (type: string, value: string) => lte(type, value)

  get defaultPagination(): DataPagination {
    return _.cloneDeep({
      page: 1,
      pageStart: 0,
      itemsPerPage: 10,
      pageStop: 0,
      pageCount: 0,
      itemsLength: 0,
    });
  }

  tables: Array<TableData> = [
    {
      status: 'supplier_confirmation',
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: 'controlling_approval',
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: 'diadoc_signing_await, signed_by_signer',
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: 'accounting_approval',
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: 'payment_await',
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: 'payment_done',
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: 'problem',
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: 'recalled',
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
  ];

  get headers() {
    return [
      {
        text: this.$t('id'),
        value: 'id',
      },
      {
        text: 'Дата создания',
        value: 'createdAt',
      },
      {
        text: 'Учетный период',
        value: 'accountingPeriod',
      },
      {
        text: this.$t('supplier'),
        value: 'supplierName',
      },
      {
        text: 'Итого без НДС',
        value: 'totalWithoutTax',
      },
    ];
  }

  async created() {
    this.calculateDefaultDates();
    this.defaultPlatform = this.userPlatforms[0]?.id || '';
    this.idsFilter = this.getFromStorage('ids');
  }

  calculateDefaultDates() {
    const dateNow = new Date();
    const dateAgo = new Date();
    dateAgo.setMonth(dateAgo.getMonth() - 1);
    dateAgo.setDate(1);
    this.defaultDates = [dateAgo.toISOString().split('T')[0], dateNow.toISOString().split('T')[0]];
  }

  beforeDestroy() {
    this.$bus.$off('preview');
  }

  reloadTables() {
    for (let i = 0; i < this.tables.length; i += 1) {
      const table = this.tables[i];
      this.reloadTable(table);
    }
  }

  async reloadTable(table: TableData) {
    const currentIndex = this.tables.findIndex((v: TableData) => v.status === table.status);
    this.tables[currentIndex].loading = true;
    const currentTable = this.tables[currentIndex];
    currentTable.pagination = table.pagination || this.defaultPagination;
    const status = table.status.split(',').map((item) => item.trim()).join(',');
    currentTable.items = await this.loadAccountingSheets(status, table.pagination || this.defaultPagination);
    // response of sheets have no total =(
    const itemsCount = currentTable.pagination.itemsPerPage * (currentTable.pagination.page - 1);
    currentTable.pagination.itemsLength = currentTable.items.length === currentTable.pagination.itemsPerPage ? (itemsCount + (currentTable.pagination.itemsPerPage * 2)) : itemsCount + currentTable.items.length;
    currentTable.loading = false;
    this.$set(this.tables, currentIndex, currentTable);
  }

  addingAttributesToAccountingSheets(lists: any[]): any[] {
    lists.forEach((item) => {
      Object.assign(item, {
        accountingPeriod: `${this.formatDate(item.startDate)} - ${this.formatDate(item.finishDate)}`,
        totalWithoutTax: this.$n(item.totalWithoutTax, 'decimal'),
      });
    });
    return lists;
  }

  formatDate(value: string): string {
    return moment(String(value)).format('DD.MM.YYYY');
  }

  async loadAccountingSheets(status: string, pagination: DataPagination): Promise<Array<any>> {
    const { page, itemsPerPage } = pagination;
    const url = accountingSheet.accountingSheetList;
    const params = {
      ids: this.idsFilter,
      dateFrom: this.dates[0],
      dateTo: this.dates[1],
      platformId: this.selectedPlatform,
      pageFrom: (page - 1) * itemsPerPage,
      pageSize: itemsPerPage,
      status,
    };
    if (this.selectedSuppliers?.length) {
      Object.assign(params, {
        suppliers: this.selectedSuppliers.join(','),
      });
    }
    try {
      const res = await Axios.get(url, {
        params,
      });
      if (res?.data?.length) {
        return this.addingAttributesToAccountingSheets(res.data);
      }
      return [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }

  async onPagination(pagination: DataPagination, table: TableData) {
    if (!this.dates?.length) {
      return;
    }
    if (pagination.itemsPerPage === table?.pagination?.itemsPerPage && pagination.pageStart === table?.pagination?.pageStart) {
      return;
    }
    table.loading = true;
    table.pagination = pagination;
    await this.reloadTable(table);
    table.loading = false;
  }

  move(item: any, to: TableData) {
    console.log('move', item, to);
  }

  async dragChange(event: any, table: TableData) {
    // send request to move item to next status
    // on successful status change or fail - reload both tables
    console.log('change', event, table);
  }

  clickRow(event: any) {
    if (event?.id) {
      this.$router.push({ name: 'AccountingSheetPage', params: { id: event.id } });
    }
  }

  async afterLoadSuppliers() {
    if (this.selectedSuppliers?.length) {
      this.selectedSuppliers = [];
    } else {
      this.reloadTables();
    }
  }

  async afterLoadingPlatforms() {
    if (this.selectedPlatform) {
      this.selectedSuppliers = this.getFromStorage('suppliers')
        .split(',')
        .filter((supplierId) => supplierId.trim() !== '');
    } else {
      this.reloadTables();
    }
  }

  @Watch('selectedSuppliers')
  async selectedSuppliersChanged() {
    this.setToStorage('suppliers', this.selectedSuppliers.join(','));
    this.reloadTables();
  }

  @Watch('dates')
  async datesChanged(value: string, oldValue: string | undefined) {
    if (value?.length && oldValue?.length) {
      this.reloadTables();
    }
  }

  filtersChanged(): boolean {
    return this.selectedSuppliers.length > 0
      || this.selectedPlatform !== this.defaultPlatform
      || this.idsFilter !== ''
      || this.dates.length !== 2
      || this.dates[0] !== this.defaultDates[0]
      || this.dates[1] !== this.defaultDates[1];
  }

  clearFilters() {
    if (this.selectedPlatform === this.defaultPlatform) {
      this.selectedSuppliers = [];
    } else {
      this.selectedPlatform = this.defaultPlatform;
    }
    this.idsFilter = '';
    this.setToStorage('ids', this.idsFilter);
    this.$bus.$emit('clear-filters');
  }
}

